import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from "@mui/styles";
import { RequestorMapping } from '../../../common/commons';
import RowMenuCell from '../grid/RowEditActions';
import { AppContext } from '../../../../RoutesWithAuth';
import axios from '../../../common/AxiosConfig';
import { LoadingIndicator } from '../reports/reconcilationreport/MuiStyled';
import DataGrid from '../grid';
import RequestTypeWrapper from './RequestTypeWrapper';
import Papa from 'papaparse';
import moment from 'moment';
import { getGridStringOperators } from '@mui/x-data-grid';
import { renderEditSingleSelectCell } from '../grid/EditSingleSelectCell';
import { Button } from '@mui/material';
import FloatingMessage from '../../../common/FloatingMessage';
import { ADMIN_PERMISSIONS } from '../../../common/RolePermissions';
import PermissionButton from '../PermissionButton';


const Requestor = [
    RequestorMapping.B2B,
    RequestorMapping.CUSTOMER,
    RequestorMapping.DRIVER,
    RequestorMapping.EMPLOYEE,
    "survivor",
    RequestorMapping.TCICUSTOMER,
];
const RequestTypeScopeValues = ['All', 'California Only', 'Non-California Only', 'Not Applicable'];

const getAdminPermission = (requestor, action) => {
    const key = String(requestor || '').toLowerCase().replace(/\s/g, '');
    const requestorKey = { 'b2b': 'B2B', customer: 'CUSTOMER', driver: 'DRIVER', employee: 'EMPLOYEE', survivor: 'SURVIVOR', tcicustomer: 'TCI_CUSTOMER' }[key];
    return ADMIN_PERMISSIONS[`APPSCOPE_${requestorKey}_${action}`];
};

const useStyles = makeStyles(() => ({
    appscopeWrapper: {
        // marginTop: '4px',
        // marginRight: '15px',
        // Custom Class for the Row When the Row has in_active = true
        '& .isInactive-row-cust-cls': {
            color: 'red'
        },
    },
    additionalRules: {
        marginTop: '10px',
        padding: '0px 0px 10px 0px',
        boxShadow: '0px 0px 1px 0px rgb(0 0 0 / 41%)',
        '& .header': {
            background: '#7f9ed7',
            padding: '5px',
            color: "white",
            fontWeight: 'bold'
        }
    },
    toolbar: {
        textAlign: "right",
        height: '35px',
        marginRight: '15px',
        '& .MuiButtonBase-root': {
            padding: '5px !important'
        }
    }
}));
function AppScope({ adminActiveTab, fromredirection, toggleError }) {

    const [appsData, setAppsData] = useState([]);
    const [additionalRules, setAdditionalRules] = useState("");
    const [selectionModel, setSelectionModel] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);

    const requestor = Requestor[adminActiveTab];
    const context = useContext(AppContext)
    const authToken = context.authToken.get

    const classes = useStyles()
    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, adminActiveTab])

    /**
     * Dispatch pending requests for a downstream app
     * @param {Object} row - The row data containing app information
     */
    const handleDispatch = (row) => {
        setIsProcessing(true);
        axios.post('apps/dispatch_requests', {
            app_id: row.originalId,
            requestor: requestor
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(() => {
            setIsProcessing(false);
            if (toggleError) {
                toggleError('Successfully dispatched requests', 'success');
            }
        }).catch((err) => {
            setIsProcessing(false);
            if (toggleError) {
                toggleError('Error encountered while dispatching requests', 'error');
            }
            console.log(err);
        });
    };

    /**
     * Render cell for the Dispatch button
     * Only shows button for API Push or Jira Push integration patterns
     */
    const renderDispatchCell = (params) => {
        const integrationPattern = params.row?.integration_pattern;
        if (integrationPattern === 'API Push' || integrationPattern === 'Jira Push') {
            return (
                <PermissionButton
                    permission={getAdminPermission(requestor, 'DISPATCH')}
                    size="small"
                    variant="contained"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleDispatch(params.row);
                    }}
                    disabled={isProcessing}
                    sx={{
                        backgroundColor: '#4472c4',
                        color: 'white',
                        textTransform: 'none',
                        fontSize: '12px',
                        padding: '2px 8px',
                        minWidth: 'auto',
                        '&:hover': {
                            backgroundColor: '#365fa3'
                        }
                    }}
                >
                    Dispatch
                </PermissionButton>
            );
        }
        return null;
    };

    const getDownStreamColumns = (gridData) => {
        return [{
            name: "#",
            mapping: "filteredRowIndex",
            width: 40,
            disableColumnMenu: true,

        }, {
            name: "Application Name",
            mapping: "display",
            valueOptions: gridData?.map(({ display }) => display),
            customSingleSelectFilter: true,
            displayTootip: ["display"],
            width: 185,
            type: 'singleSelect',
        },{
            name: "Tier",
            mapping: "tier",
            valueOptions: [...new Set(gridData?.map(({ tier }) => tier))],
            editable: false,
            width: 100,
            type: 'singleSelect',
            customSingleSelectFilter:true
        },
        {
            name: "Integration Pattern",
            mapping: "integration_pattern",
            width: 180,
            type: 'singleSelect',
            valueOptions: ['API Pull', 'API Push', 'FTP Push', 'Jira Push'],
            customSingleSelectFilter: true
        }, {
            name: "Request Json",
            mapping: "request_json",
            width: 180,
            type: 'singleSelect',
            isFTPNonEditable: true,
            editable: true,
            getValueOptions : (row)=>{
                if(row.integration_pattern === "Jira Push") {
                    return ['CPS Json', 'Non-PI Json', 'Not Applicable', 'Upstream Json']
                }
                return  ['CPS Json', 'Non-PI Json', 'Upstream Json']
            },
            renderEditCell : renderEditSingleSelectCell,
            // valueOptions:,
            filterOptions: ['CPS Json', 'Non-PI Json', 'Not Applicable', 'Upstream Json'],
            customSingleSelectFilter: true
        }, {
            name: "Request Automated",
            mapping: "is_request_automatedText",
            editable: true,
            isFTPNonEditable: true,
            width: 180,
            type: 'singleSelect',
            valueOptions: ['Yes', 'No', 'N/A'],
            customSingleSelectFilter: true
        }, {
            name: "RTC",
            mapping: "rtc_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "RTD",
            mapping: "rtd_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "RTK",
            mapping: "rtk_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "RTO",
            mapping: "rtoo_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "Send Requests",
            mapping: "send_requests",
            width: 120,
            editable: false,
            disableColumnMenu: true,
            renderCell: renderDispatchCell
        }, {
            name: "Is Active",
            mapping: "is_active",
            editable: true,
            type: 'singleSelect',
            valueOptions: ['True', 'False'],
            customSingleSelectFilter: true,
            width: '125'
        }, {
            name: "Edit",
            mapping: "actions",
            adminEnabled: true,
            adminPermission: getAdminPermission(requestor, 'EDIT'),
            width: 80,
            editable: false,
            renderCell: RowMenuCell,
            disableColumnMenu: true,

        }];
    }
    const getDriverColumns = (gridData) => {
        return [{
            name: "#",
            mapping: "filteredRowIndex",
            width: 40,
            disableColumnMenu: true,
        }, {
            name: "Application Name",
            mapping: "display",
            valueOptions: gridData?.map(({ display }) => display),
            customSingleSelectFilter: true,
            displayTootip: ["display"],
            width: 185,
            flex: 1,
            type: 'singleSelect',
        }, {
            name: "Tier",
            mapping: "tier",
            valueOptions: [...new Set(gridData?.map(({ tier }) => tier))],
            editable: false,
            width: 100,
            type: 'singleSelect',
            customSingleSelectFilter: true
        }, {
            name: "Integration Pattern",
            mapping: "integration_pattern",
            width: 180,
            type: 'singleSelect',
            valueOptions: ['API Pull', 'API Push', 'FTP Push', 'Jira Push'],
            customSingleSelectFilter: true
        }, {
            name: "Request Json",
            mapping: "request_json",
            width: 180,
            type: 'singleSelect',
            isFTPNonEditable: true,
            editable: true,
            getValueOptions: (row) => {
                if (row.integration_pattern === "Jira Push") {
                    return ['CPS Json', 'Non-PI Json', 'Not Applicable', 'Upstream Json']
                }
                return ['CPS Json', 'Non-PI Json', 'Upstream Json']
            },
            renderEditCell: renderEditSingleSelectCell,
            filterOptions: ['CPS Json', 'Non-PI Json', 'Not Applicable', 'Upstream Json'],
            customSingleSelectFilter: true
        }, {
            name: "Request Automated",
            mapping: "is_request_automatedText",
            editable: true,
            width: 180,
            type: 'singleSelect',
            valueOptions: ['Yes', 'No'],
            customSingleSelectFilter: true
        }, {
            name: "TVLA",
            mapping: "tvla_scope",
            editable: true,
            width: 150,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "Send Requests",
            mapping: "send_requests",
            width: 120,
            editable: false,
            disableColumnMenu: true,
            renderCell: renderDispatchCell
        }, {
            name: "Is Active",
            mapping: "is_active",
            editable: true,
            type: 'singleSelect',
            valueOptions: ['True', 'False'],
            customSingleSelectFilter: true,
            width: '125'
        }, {
            name: "Edit",
            mapping: "actions",
            adminEnabled: true,
            adminPermission: getAdminPermission(requestor, 'EDIT'),
            width: 80,
            editable: false,
            renderCell: RowMenuCell,
            disableColumnMenu: true,
        }];
    }
    const getSurvivorColumns = (gridData) => {
        return [{
            name: "#",
            mapping: "filteredRowIndex",
            width: 40,
            disableColumnMenu: true,

        }, {
            name: "Application Name",
            mapping: "display",
            valueOptions: gridData?.map(({ display }) => display),
            customSingleSelectFilter: true,
            displayTootip: ["display"],
            width: 185,
            type: 'singleSelect',
        },{
            name: "Tier",
            mapping: "tier",
            valueOptions: [...new Set(gridData?.map(({ tier }) => tier))],
            editable: false,
            width: 100,
            type: 'singleSelect',
            customSingleSelectFilter:true
        },
        {
            name: "Integration Pattern",
            mapping: "integration_pattern",
            width: 180,
            type: 'singleSelect',
            valueOptions: ['API Pull', 'API Push', 'FTP Push', 'Jira Push'],
            customSingleSelectFilter: true
        }, {
            name: "Request Json",
            mapping: "request_json",
            width: 180,
            type: 'singleSelect',
            isFTPNonEditable: true,
            editable: true,
            getValueOptions : (row)=>{
                if(row.integration_pattern === "Jira Push") {
                    return ['CPS Json', 'Non-PI Json', 'Not Applicable', 'Upstream Json']
                }
                return  ['CPS Json', 'Non-PI Json', 'Upstream Json']
            },
            renderEditCell : renderEditSingleSelectCell,
            // valueOptions:,
            filterOptions: ['CPS Json', 'Non-PI Json', 'Not Applicable', 'Upstream Json'],
            customSingleSelectFilter: true
        }, {
            name: "Request Automated",
            mapping: "is_request_automatedText",
            editable: true,
            isFTPNonEditable: true,
            width: 180,
            type: 'singleSelect',
            valueOptions: ['Yes', 'No', 'N/A'],
            customSingleSelectFilter: true
        }, {
            name: "AWL",
            mapping: "awl_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "DA",
            mapping: "deactivate_account_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "ISR",
            mapping: "isr_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "RTT",
            mapping: "rtt_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "RWL",
            mapping: "rwl_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "UFV",
            mapping: "ufv_scope",
            editable: true,
            width: 120,
            type: 'singleSelect',
            valueOptions: RequestTypeScopeValues,
            customSingleSelectFilter: true
        }, {
            name: "Send Requests",
            mapping: "send_requests",
            width: 120,
            editable: false,
            disableColumnMenu: true,
            renderCell: renderDispatchCell
        }, {
            name: "Is Active",
            mapping: "is_active",
            editable: true,
            type: 'singleSelect',
            valueOptions: ['True', 'False'],
            customSingleSelectFilter: true,
            width: '125'
        }, {
            name: "Edit",
            mapping: "actions",
            adminEnabled: true,
            adminPermission: getAdminPermission(requestor, 'EDIT'),
            width: 80,
            editable: false,
            renderCell: RowMenuCell,
            disableColumnMenu: true,

        }];
    }
    /**
     * Method returns a unique appId Based on the Active Tab
     * The Unique combination is app_id + requestor (based on Active Tab)
     * 
     * @param {app Details} app 
     * @returns AppId
     */
    const getuniqueAppId = (app) => {
        return app.id + requestor;
    }
    const fetchData = () => {
        setIsProcessing(true);
        setAppsData([])
        const params = {
            requestor
        }
        axios.get("apps", {
            headers: {
                Authorization: authToken
            },
            params
        }).then(res => {
            let selection = [];
            let addit_rule = "";
            const data = Array.isArray(res.data) ? res.data : [];
            if (data.length > 0) {
                selection = [getuniqueAppId(data[0])];
                addit_rule = data[0].additional_rules || "None";
            }
            setAppsData(data)
            setAdditionalRules(addit_rule)
            setSelectionModel(selection);
            setIsProcessing(false);
        }).catch(err => {
            setIsProcessing(false);
            console.log(err)
        })
    }
    const updateDownstreamApps = (rowInfo) => {
        setIsProcessing(true)
        const payload = {
            app_id: rowInfo.originalId,
            is_request_automated: rowInfo.is_request_automatedText === "Yes",
            is_response_automated: rowInfo.is_response_automatedText === "Yes",
            isr_scope: rowInfo.isr_scope,
            awl_scope: rowInfo.awl_scope,
            deactivate_account_scope: rowInfo.deactivate_account_scope,
            rwl_scope: rowInfo.rwl_scope,
            ufv_scope: rowInfo.ufv_scope,
            rtc_scope: rowInfo.rtc_scope,
            rtt_scope: rowInfo.rtt_scope,
            rtd_scope: rowInfo.rtd_scope,
            rtk_scope: rowInfo.rtk_scope,
            rtoo_scope: rowInfo.rtoo_scope,
            requestor: rowInfo.requestor,
            is_active: rowInfo.is_active === "True",
            request_json: rowInfo.request_json
        };
        payload.tvla_scope = rowInfo.tvla_scope;
        axios.post(`apps`, payload, {
            headers: {
                Authorization: authToken
            }
        })
            .then(res => {
                fetchData()
            }).catch(err => {
                setIsProcessing(false)
                console.log(err)
            })
    }
    const updateApp = (rowInfo) => {
        updateDownstreamApps(rowInfo);
    }
    const dataGridColumns = (gridData) => {
        if(requestor ==="survivor"){
            return getSurvivorColumns(gridData);
        }
        if(requestor === "Driver"){
            return getDriverColumns(gridData);
        }
        return getDownStreamColumns(gridData);
    }
    const appsGridData = () => {
        return appsData?.map((row, i) => {
            const isFTPPush = row.integration_pattern === "FTP Push";
            const showFTPNA = isFTPPush && requestor !== "Driver";
            return {
                rowId: (i + 1),
                filteredRowIndex: (i + 1),
                is_request_automatedText: showFTPNA ? "N/A" : (row.is_request_automated ? "Yes" : "No"),
                is_response_automatedText: row.is_response_automated ? "Yes" : "No",
                ...row,
                id: getuniqueAppId(row),
                originalId: row.id,
                is_active: row.is_active ? "True" : "False",
                routing_automated: row.comm_type === "REQUEST" ? "Request Automated" : "Response Automated",
            }
        })
    }
    const downloadAppScopeData = (rows) => {
        const downloadLink = document.createElement("a");
        let columnsData =[]
        if(requestor ==="survivor"){
            columnsData = getSurvivorColumns([])
        }else if(requestor === "Driver"){
            columnsData = getDriverColumns([])
        }else{
            columnsData = getDownStreamColumns([])
    }
        const formatedReportData = rows?.map((record) => {
            const formatedRecord = {};
          
        columnsData.forEach(element => {
            if (element.name !== "#" && element.name !== "Edit" && element.name !== "Send Requests") {
                let valueFormated = record[element.mapping];
                formatedRecord[element.name] = valueFormated;
            }
        });
            return formatedRecord;
        });
        const csv = Papa.unparse(formatedReportData)
        const blob = new Blob(["\ufeff", csv])
        const url = URL.createObjectURL(blob)
        downloadLink.href = url
        // Formating the CSV File Name
        const timestamp = moment().format("YYYYMMDDHHmm")
        downloadLink.download = `App scope_${requestor}_${timestamp}.csv`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    }
    const appscopeGridData = appsGridData();
    /**
     * Returns is_active default filter for the data Grid
     * @returns Default Filters that are to be applied to the data Grid
     */
    const applyDefaultFilters = () => {
        return {
            defaultFilterOrder: ["is_active"],
            defaultFilters: {
                "is_active": {
                    "columnField": "is_active",
                    "id": 435,
                    "operatorValue": "equals",
                    "value": "True",
                    "columnInfo": {
                        "filterable": true,
                        "type": "singleSelect",
                        "align": "left",
                        "filterOperators": getGridStringOperators().filter((operator) => {
                            return operator.value === "equals";
                        }),
                        "field": "is_active",
                        "name": "Is Active",
                        "mapping": "is_active",
                        "valueOptions": [
                            "True",
                            "False"
                        ],
                        "customSingleSelectFilter": true,
                    }
                }
            }
        }
    }
    return (
        <div className={classes.appscopeWrapper}>
            {isProcessing && (<LoadingIndicator />)}
            <DataGrid
                toolbarConfig={{
                    downloadLabel: "Download",
                    handleNoRowDownloadDisabled: true,
                    handleDownloadGrid: downloadAppScopeData
                }}
                disableSelectionOnClick={false}
                enableCustomFiltering={true}
                key={requestor}
                columns={dataGridColumns(appscopeGridData)}
                selectionModel={selectionModel}
                clearFilterSortState={requestor + fromredirection}
                getRowClassName={(params) => {
                    const _classes = [];
                    // For Displaying the Custom Class for the IsActive Row
                    if (params?.row?.is_active === "False") {
                        _classes.push("isInactive-row-cust-cls");
                    }
                    return _classes.join(" ");
                }}
                isCellEditable={(cellParams) => {
                    // Disabling the Edit Functionaly only for FTP Records.
                    if (cellParams.colDef.isFTPNonEditable) {
                        return cellParams.row.integration_pattern !== "FTP Push";
                    }
                    return cellParams.colDef.editable;
                }}
                {...applyDefaultFilters()}
                onSelectionModelChange={(selection) => {
                    !isProcessing && setSelectionModel(selection);
                    const selectedAppData = appsData.find((app) => {
                        return getuniqueAppId(app) === selection[0]
                    })
                    !isProcessing && setAdditionalRules(selectedAppData?.additional_rules || "None");
                }}
                rows={appscopeGridData}
                onRowEditCommit={(rows, event) => {
                    if (event.rowInfo) {
                        updateApp(event.rowInfo);
                    }
                }}
            />
            <div className={classes.additionalRules}>
                <div className={"header"}>
                    Application Additional Rules
                </div>
                <div>
                    {additionalRules}
                </div>
            </div>

        </div>
    )
}
export default React.memo(AppScope);

const useWrapperStyles = makeStyles(() => ({
    headerWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
}));

const AppScopeWrapper = (parentprops) => {
    const classes = useWrapperStyles();
    const [error, setError] = useState('');
    const [messageType, setMessageType] = useState('error');

    return (
        <>
            <FloatingMessage open={error !== ''} message={error} severity={messageType} onClose={() => setError('')} />
            <RequestTypeWrapper
                title={"APPS SCOPE"}
                routePath={"appsscope"}
                additionalTab={[{
                    name: "driver",
                    display: "Driver"
                },{
                    name: "survivor",
                    display: "survivor"
                }]}
                renderTabContent={(props) => {
                    return <AppScope
                        adminActiveTab={props.activeTab}
                        toggleError={(msg, type = 'error') => {
                            setError(msg);
                            setMessageType(type);
                        }}
                        {...props} />
                }}
                {...parentprops}
            />
        </>
    );
}
export const AppScopeTab = React.memo(AppScopeWrapper);